  import React from "react";
  import Header from "../components/Header";
  import Footer from "../components/Footer";
  import ResponsiveFooter from "../components/Reaponsivefooter";
  import { Outlet } from "react-router-dom";
  import '../App.css'

  const MainLayout = () => {
    return (
      <>
        <Header />
        <main className="main-layout-content"   style={{ minHeight: "80vh" }}>
          <Outlet />
        </main>
        <Footer />
        <ResponsiveFooter />
      </>
    );
  };

  export default MainLayout;
